// Focus one part of the shared address form after a refused submit (BL-2696; moved
// here from admin-frontend by BUG-2600 so bidder's onboarding step uses the same helper).
// `AddressFormFields` inputs are controlled, not registered, so RHF's own
// focus-on-error can't reach them (rule #27 pillar 5): callers find the part by its test id.
import type { AddressValue } from '../components/AddressFormFields';

/** The shared address form's parts, in reading order. */
export const ADDRESS_PART_ORDER: readonly (keyof AddressValue)[] = ['street', 'city', 'state', 'postalCode', 'country'];

/**
 * Focus the first address part that shows an error.
 *
 * @param input.root - The element the address form sits in.
 * @param input.testIdPrefix - The `testIdPrefix` the form was given.
 * @param input.hasError - Whether a part shows an error.
 * @returns True when a part took focus.
 * @sideEffect Moves browser focus to the matching input.
 */
export function focusFirstAddressPart(input: { root: HTMLElement | null; testIdPrefix: string; hasError: (part: keyof AddressValue) => boolean }): boolean {
  const part = ADDRESS_PART_ORDER.find(input.hasError);
  const target = part == null ? null : input.root?.querySelector<HTMLElement>(`[data-testid="${input.testIdPrefix}-${part}"]`);
  target?.focus();
  return target != null;
}
